module.exports = __webpack_public_path__ + "fonts/sourcesansprosemibold.084fc1ae.woff2";